import { ContentService } from "@DavisDigital/davisdigitalfrontend.module";
import { FolderTypes } from "@DavisDigital/interfaces";


class AddEditFolderModalController {
    
    private close:Function; //injected from modal-service
    
    public folderId:    string;
    public folderName:  string;
    public folderType:  FolderTypes;
    public sourcePage: string = "";
    
    public modalTitle:  "Create Folder" | "Edit Folder" = "Create Folder";
    public modalInputLabel: string;
    public successMessage: string;
    public isLoading = false;
    public isSaveSuccess = false;
	
	// @ngInject
	constructor(
	    private $timeout : ng.ITimeoutService,
	    private contentService: ContentService
	){}
	
	public $onInit = () => {
	    
	    if( this.folderId?.trim() ){
	        this.modalTitle = "Edit Folder";
	        this.modalInputLabel = this.folderName;
	    } 
	    else {
	        this.modalInputLabel = 'Folder Name'; //we're creating a new folder
	    }
	}
	
	public onSave = () => {
	    
	    if( this.folderId?.trim() ){
	        this.updateFolder();
	    } 
	    else {
	        this.createFolder();
	    }
	}
	
	public createFolder = () => {
		this.isLoading = true;
		this.contentService.createFolder(this.folderName, this.folderType)
		.then( res => {
			if( !res?.successfulActions?.includes('createFolder') ){
				throw(res)
			}
			this.isSaveSuccess = true;
			this.successMessage = `Folder ${this.folderName} has been created successfully`;
		})
		.finally(() => this.isLoading = false);
	}
	
	public updateFolder = () => {
	    this.isLoading = true;
	    this.contentService.updateFolder({
            folderID: this.folderId, 
            title: this.folderName, 
            folderType_systemCode: this.folderType
        })
        .then( (res) => {
            if( !res?.successfulActions?.includes('updateFolder') ){
                throw(res);
            }
            this.isSaveSuccess = true;
            this.successMessage = `Folder ${this.folderName} has been updated successfully`;
        })
        .finally(() => this.isLoading = false);
	}
	
    private closeModal = () =>{
    	if( this.sourcePage == "listing") {
    		this.close({ 'status': this.isSaveSuccess, 'folderName': this.folderName });
    	} else {
    		this.close(this.isSaveSuccess);
    	}
		
	}
    
}

class AddEditFolderModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    folderId: "<",
	    folderName: "<",
	    folderType: "<?",
	    sourcePage: "<?",
		close:'='
	};

	public controller = AddEditFolderModalController;
	public controllerAs = 'folderModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/add-edit-folder-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddEditFolderModal };
